//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DpButton from '../button/Button.vue';
import DpControlGroup from './ControlGroup.vue';

export default {
  name: 'DpPageTitleNavigation',
  components: {
    DpButton,
    DpControlGroup,
  },
  props: {
    title: { type: String, default: 'Back' },
    forward: { type: Boolean, default: false },
    routerLink: { type: Object, default: () => ({}) },
  },
  computed: {
    icon() {
      return this.forward ? 'arrow-right' : 'arrow-left';
    },
  },
  methods: {
    navigate() {
      const { routerLink } = this;
      if (this.$router && routerLink && Object.keys(routerLink).length > 0) {
        this.$router.push(routerLink).catch(() => {});
      }
      this.$emit('navigate');
    },
  },
};
